import React, { Component } from "react";
import {
  StyleSheet,
  View,
  Text,
  Keyboard,
  ScrollView,
  SafeAreaView,
} from "react-native";

export default function BackgroundUser(props) {
  if (props.scroll) {
    return (
      <SafeAreaView style={{ height: "100%" }}>
        <ScrollView contentContainerStyle={styles.containerScroll}>
          {props.children}
          <View style={styles.containerText}>
            <Text style={styles.textBackground}>Cita{"\n"}Previa</Text>
          </View>
        </ScrollView>
      </SafeAreaView>
    );
  } else {
    return (
      <View style={styles.container}>
        {props.children}
        <View style={styles.containerText}>
          <Text style={styles.textBackground}>Cita{"\n"}Previa</Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  containerText: {
    height: 250,
    width: "100%",
    position: "absolute",
    bottom: 0,
    flex: 1,
    alignItems: "flex-end",
    zIndex: -1000,
  },
  textBackground: {
    fontSize: 106,
    color: "rgba(255, 255, 255, 0.50)",
    paddingTop: 120,
    fontWeight: "900",
    fontFamily: "Nunito-Black",
    lineHeight: 85,
    left: 4,
    position: "absolute",
    overflow: "visible",
    bottom: -20,
    letterSpacing: -0.06,
    alignSelf: "flex-end",
  },
  containerScroll: {
    marginTop: 30,
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#F0F0F0",
    flexDirection: "column",
  },
  container: {
    justifyContent: "space-around",
    width: "100%",
    backgroundColor: "#F0F0F0",
    flexDirection: "column",
    flex: 1,
    flexGrow: 1,
  },
});
